import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AlertService } from '../../../services/alert/alert.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PlayerComponent } from '../../spots/player/player.component';
import { ClientFaceDetail, toClientFace, toWancomFace, ClientFaceDiffusion, DayOfWeekFlags, FaceDetail, getSubClassName, WancomCampaign, WancomFaces } from '../park.model';
import { environment } from '../../../../environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GetDeviceListPowerStatusResponse, RemoteTvCmdService } from '../../../services/remote-Tv-Cmd/remote-tv-cmd.service';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { FaceService, FilteredFaceDetailsParams } from '../../private-campaign/services/face.service';
import { Router } from '@angular/router';
import { ScreenMapComponent } from '../../../helpers/dialog/screen-map/screen-map.component';
import { FaceTimeWork } from '../../../services/face-Time-Work/faceTimeWork.model';
import { ScreenParametersComponent } from '../screen-parameters/screen-parameters/screen-parameters.component';
import { MagicInfoPowerStatus } from '../park/park.component';
import { DiffusionListComponent } from './diffusion-list/diffusion-list.component';
import { UserTagsService } from '../../../services/user/userTags.service';
import { ScreenService } from '../../store/services/screen.service';
import { UploadFileDialogComponent } from '../../../helpers/dialog/upload-file-dialog/upload-file-dialog.component';
import { StoredFile } from '../../../services/file/file.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { ConfirmationDialogComponent } from '../../../helpers/dialog/confirmation-dialog/confirmation-dialog.component';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
    selector: 'app-screen-info',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatMenuModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        DiffusionListComponent,
        MatDialogModule,
        DragDropModule
    ],
    templateUrl: './screen-info.component.html',
    styleUrl: './screen-info.component.scss'
})
export class ScreenInfoComponent implements OnInit {

    @Input() public face: FaceDetail;
    /**
        * Liste de FaceIds d'écrans MagicInfo allumés
        */
    @Input() public poweredFaceIds?: GetDeviceListPowerStatusResponse[];
    @Input() public filterParams: FilteredFaceDetailsParams;
    /**
     * Event lors d'un changement de l'ordre dans la playlist
     */
    @Output() playlistOrderChanged = new EventEmitter<number>();
    @Output() diffusionsDeleted = new EventEmitter<ClientFaceDiffusion>();
    @Output() diffForScreenDeleted = new EventEmitter<{ diffusion: ClientFaceDiffusion, faceId?: number }>();

    @ViewChildren(DiffusionListComponent) diffList: QueryList<DiffusionListComponent>;

    public baseUrl: string;
    public baseUrlPdf: string;
    /**
     * Type d'écran à afficher
     * Permet de différencier un écran Client / Wancom
     */
    public screenType: 'Wancom' | 'Client' | 'Unknown';

    // MARK: CONSTRUCTOR
    constructor(
        private readonly alert$: AlertService,
        public userAuth$: UserAuthService,
        private readonly dialog: MatDialog,
        private readonly router: Router,
        private readonly remotTvCmd$: RemoteTvCmdService,
        public screen$: ScreenService,
        private readonly face$: FaceService,
        private readonly waiting$: WaitingService
    ) {
        this.baseUrl = environment.apiBaseUrl;
        this.baseUrlPdf = environment.apiBasePdf;
    }

    ngOnInit(): void {
        this.screenType = getSubClassName(this.face);

    }


    getTagIcon(tagId: number) {
        return UserTagsService.getTagIcon(tagId);
    }

    public playScreenFile(storageId: any) {
        const dialogRef = this.dialog.open(PlayerComponent, {});
        dialogRef.componentInstance.fileStorageId = storageId;

        dialogRef.componentInstance.loadVideo();
    }

    public getDayofWeeks(dayOfWeek: DayOfWeekFlags) {
        const uniqueday: string = DayOfWeekFlags[dayOfWeek];

        if (uniqueday != null) {
            return uniqueday;
        } else {
            let tabDay: number[] = [];
            for (let index: number = 64; index >= 1; index = index / 2) {
                if (dayOfWeek - index >= 0) {
                    dayOfWeek -= index;
                    tabDay.push(index);
                }
            }

            tabDay.sort((a: number, b: number) => {
                return a - b;
            });

            let dayStr: string = '';
            tabDay.forEach((day) => {
                dayStr += DayOfWeekFlags[day] + ', ';
            });

            return dayStr.slice(0, -2);
        }
    }

    public redirectToTimeline(face: FaceDetail) {
        this.router.navigateByUrl('/timeline?faceId=' + face.faceId);

    }

    public seeScreenMap(lat: any, lon: any) {
        this.dialog.open(ScreenMapComponent, {
            data: {
                latitude: lat,
                longitude: lon,
            },
        });
    }

    public createTicket(face: any) {
        this.router.navigateByUrl(`tickets/create?&faceId=${face.faceId}`);
    }

    public openScreenParameters(face: any) {
        if (face?.powerStatus_MagicInfo === 1 && face.isMagicInfo) {
            const ScreenParametersDialogRef: MatDialogRef<ScreenParametersComponent> =
                this.dialog.open(ScreenParametersComponent, {
                    data: {
                        faceId: face.faceId,
                        screenName: face.screenCode,
                        readOnly: false,
                    },
                    width: '95%',
                });

            ScreenParametersDialogRef.afterClosed().subscribe(
                (newFaceTimeWorks?: FaceTimeWork[]) => {
                    if (
                        newFaceTimeWorks != null &&
                        newFaceTimeWorks.length > 0
                    ) {
                        //Reload faceTimeWork pour cette face
                        face.timeWorks = newFaceTimeWorks;
                    }
                }
            );
        } else {
            this.dialog.open(ScreenParametersComponent, {
                data: {
                    faceId: face.faceId,
                    screenName: face.screenCode,
                    readOnly: true,
                },
                width: '95%',
            });
        }
    }

    public setPowerDevice(face, powerValue: boolean = true) {
        this.remotTvCmd$.setPowerFace(face.faceId, powerValue).subscribe(() => {
            this.alert$.show({
                message: 'Information envoyée avec succès !',
                duration: 500,
            });

            switch (face.powerStatus_MagicInfo) {
                case MagicInfoPowerStatus.On:
                    if (!powerValue) {
                        face.powerStatus_MagicInfo =
                            MagicInfoPowerStatus.Loading;
                        setTimeout(() => {
                            this.getFacePowerState(face);
                        }, 5000);
                    } else {
                        return;
                    }
                    break;
                case MagicInfoPowerStatus.Off:
                    if (powerValue) {
                        face.powerStatus_MagicInfo =
                            MagicInfoPowerStatus.Loading;
                        setTimeout(() => {
                            this.getFacePowerState(face);
                        }, 36000);
                    } else {
                        return;
                    }
                    break;
                case MagicInfoPowerStatus.Loading:
                default:
                    break;
            }
        });
    }

    private getFacePowerState(face: any) {
        this.remotTvCmd$.getDevicePowerStatus(face.faceId).subscribe({
            next: (isOn: boolean) => {
                face.powerStatus_MagicInfo = isOn
                    ? MagicInfoPowerStatus.On
                    : MagicInfoPowerStatus.Off;
            },
            error: (err) => {
                console.error(err);
                face.powerStatus_MagicInfo = MagicInfoPowerStatus.Off;
            },
        });
    }

    public toWancomFace(face: FaceDetail): WancomFaces {
        return toWancomFace(face);
    }

    public toClientFace(face: FaceDetail): ClientFaceDetail {
        return toClientFace(face);
    }

    public drop(
        event: { previousIndex: number; currentIndex: number },
        diffusionList: ClientFaceDiffusion[],
        faceId: number
    ) {


        if (event.currentIndex !== event.previousIndex) {
            moveItemInArray(
                diffusionList,
                event.previousIndex,
                event.currentIndex
            );

            this.updatePlaylistOrder(faceId);
        }
    }

    /**
     *
     * @param campaign Campagne d'où récupérer le lien vers la facture/Commande
     * @returns L'url du PDF
     */
    public getOrderFormLink(campaign: WancomCampaign): string {
        return `${this.baseUrlPdf}/Pdf/${campaign.orderType === 0 ? 'BDC' : 'Facture'
            }/${campaign.orderFormId}/${campaign.orderFormDownloadCode
            }/${this.getOrderFormName(campaign)}.pdf`;
    }

    /**
     *
     * @param campaign Campagne d'où récupérer les infos
     * @returns BDC ou Fa avec le numéro de facture
     */
    public getOrderFormName(campaign: WancomCampaign) {
        return `${campaign.orderType === 0 ? 'BDC-' : 'FA-'}${campaign.orderFormNumber
            }`;
    }

    updatePlaylistOrder(faceId: number) {
        this.playlistOrderChanged.emit(faceId);
    }

    /**
     * openScreenUploader
     */
    public openScreenUploader() {

        if (!this.userAuth$.hasRight('CanEditScreenPicture')) {
            this.alert$.show({
                message: "Vous n'avez pas les droits suffisants pour modifier l'image de cet écran",
                duration: 1700
            });
            return;
        }

        const uploadDialogRef = this.dialog.open(UploadFileDialogComponent);
        uploadDialogRef.componentInstance.title = `Ajout d'une photo pour l'écran '${this.face.screenCode}'`

        uploadDialogRef.afterClosed().subscribe((storedFile?: StoredFile) => {
            if (storedFile) {
                //Update 
                this.changePictureFace(storedFile);

            }
        });
    }

    private changePictureFace(storedFile: StoredFile) {
        const waitingId: string = this.waiting$.start();
        this.face$.changePictureFace(this.face.faceId, storedFile.id).subscribe({
            next: () => {
                this.waiting$.end(waitingId);
                this.face.thumbnailStorageId = storedFile.thumbnailStorageId;

                this.alert$.show({
                    message: "Image modifiée !",
                    duration: 1700
                });

            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);
                console.error("ScreenInfoComponent - changePictureFace() : ", err);

            }
        });
    }

    /**
     * deletePic
     */
    public deletePic(face) {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                title: "Suppression de l'image de l'écran",
                message: "Etes-vous sûr de vouloir supprimer l'image de votre écran ?",
                okText: "Valider",
                cancelText: "Annuler"
            }
        });

        dialogRef.afterClosed().subscribe((res) => {

            if (res.response) {
                const waitingId: string = this.waiting$.start();
                this.face$.removePictureFace(this.face.faceId).subscribe({
                    next: () => {
                        this.waiting$.end(waitingId);

                        this.face.thumbnailStorageId = null;

                        this.alert$.show({
                            message: "Image de l'écran supprimée !",
                            duration: 1700
                        });

                    },
                    error: (err: HttpErrorResponse) => {
                        this.waiting$.end(waitingId);

                        console.error("ScreenInfoComponent - RemovePictureFace() : ", err);

                        this.alert$.show({
                            message: "Erreur lors de la suppression de l'image, veuillez ré-essayer plus tard",
                            duration: 1700
                        });

                    }
                })
            }

        });
    }
}


